import { Component, OnInit, OnDestroy } from '@angular/core'

import { HttpClient } from '@angular/common/http'
import { environment } from '.../../environments/environment'
import { MomentDateAdapter } from '@angular/material-moment-adapter'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core'

import { Observable, Subscription } from 'rxjs/Rx'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '../../_services/index'
import { utils, write, WorkBook } from 'xlsx'
import { saveAs } from 'file-saver'
import { Broadcaster } from '.../../environments/broadcaster'
import { LoaderService } from '../../_services/loader.service'
import Swal from 'sweetalert2'

import * as _moment from 'moment'
import * as _rollupMoment from 'moment'
import * as _ from 'lodash'
import { GroupDescriptor, process, State } from '@progress/kendo-data-query'
import {
  DataStateChangeEvent,
  GridDataResult,
} from '@progress/kendo-angular-grid'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'

const moment = _rollupMoment || _moment
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
declare var $: any
declare var google: any
declare var firebase: any
declare var MapLabel: any
var stopAnimation = true

declare const MarkerClusterer
const distinctStatus = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.ISACTIVE === x.ISACTIVE) === idx,
  )
@Component({
  selector: 'app-khatta-point',
  templateUrl: './khatta.component.html',
  styleUrls: ['./khatta.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class khattaPointsComponent implements OnInit, OnDestroy {
  standBy: any
  public polyline_array
  routeAccuracy: any
  multiRoute: any
  assignWard: any
  tripData: any
  beatName: any
  clickedEntity: any
  clickedMarker: any
  IEMI: any
  VEHNO: any
  notInDb: any
  totalNotInDb: any
  tempVehiclesData: any
  mapLabelArray: any
  public drivingSummary: any
  public projectID: any
  public project: any
  public map: any
  public projectMaster: any
  public vehiclesData = []
  public selectedlist: number
  public vehiclesLocation: any
  public vehiclesRoute: any
  public search: any
  public selectedProjectId: any
  public PRJNAME: any
  public polygondData: any
  public prjID: any
  public date = moment()
  public latlongs = []
  public routesData: any
  countData: any
  all: any
  inactive: any
  notmoving: any
  active: any
  live: any
  offline: any
  old: any
  mismatch = 0
  notInDbAndLiveArray = []
  notInDbAndOfflineArray = []
  deadAndLive: any
  notInDbAndLive = 0
  notInDbAndOffline = 0
  dead: any
  routePath: any
  inactiveArray = []
  activeArray = []
  liveArray = []
  offlineArray = []
  oldArray = []
  mismatchArray = []
  notmovingArray = []
  deadArray = []
  dataWithoutDead = []
  activeAndLive = []
  vehiclesDataTemp: any
  isLive: any
  a = []
  route: any
  markerStart: any
  markerEnd: any
  currentVehiclesData: any
  vehiclesNo: any
  IMEI: any
  vehiclesType: any
  mobileNo: any
  startTime: any
  endTime: any
  geocoder: any
  currentAddress: any
  Liveroute: any
  distance: any
  stopAnimation: any
  allMarkers = []
  autoTicks = false
  disabled = false
  invert = false
  max = 1000
  public value: any
  min = 0
  showTicks = false
  step = 1
  thumbLabel = false
  position = [43, -89]
  vertical = false
  counter: any
  public icon: any
  totalStop: any
  totalDuration: any
  vechicleListIsClicked: any
  servingWardName: any
  servingBeat: any
  stopSummary: any
  totalStopBeat: any
  wardBoundary: any
  beatBoundary: any
  routeBoundary
  polygon: any
  infoWindowStart: any
  infoWindowEnd: any
  controlText: any
  centerControlDiv: any
  vehicleCluster: any
  markerCluster: any
  deadVehicleSummary: any
  notRunningSince15Days: any
  notRunningSince10Days: any
  notRunningSince5Days: any
  notRunningSince2Days: any
  notRunningSince15DaysArray: any
  notRunningSince10DaysArray: any
  notRunningSince5DaysArray: any
  notRunningSince2DaysArray: any
  deadVehicleList: any
  selectedDeadList: any
  searchDeadList: any
  runningVehiclesByType: any
  isStats: any
  totalWorking: any
  totalAvilable: any
  showLoader: any
  isClickedVehicle: any
  vehicleInfoWindow: any
  vehicleInfoWindowClicked: any
  plotSecondary: any

  plotKhattaPoint: any
  plotClosedKhattaPoint: any
  plotParking: any
  plotFCTS: any
  plotPCTS: any
  plotMTS: any
  plotBins: any

  secondaryPointData = []
  secPointMarker: any
  wardPolygonList: any
  vehicleInWard: any
  lastActiveTime: any
  fuelTypeCount: any
  maintenanceStatusCount: any
  maintenanceStatusVtsCount: any
  currentAddressStart: any
  filterData: any = {}
  ownerList: any
  vehicleCategoryList: any
  fuelTypeList: any
  areaAssignment: any
  staffAssignment: any
  VEHID: any
  zoneWardInfoWindow: any
  authtoken: any
  zonesList: any
  isLko: boolean = false
  plotPlant: any
  zonesListing: any
  zonesData: any

  liveStandBy: any
  DNRStandBy: any
  liveMaint: any
  DNRMaint: any
  totalRunning: number

  private subscription: Subscription
  isUnderMaintenance: boolean = false
  isAssignment: boolean = false
  isCustomLoading: boolean = false
  wardsList: any
  isZoneSelected: boolean = false
  zoneID: any
  isWardSelected: boolean = false
  wardID: any
  wardPolygondData: any
  wardName: any
  khattaVehicleID: number[]
  searchKhatta: any
  searchVeh: any
  khattaResult: any

  // kendogrid sysytem

  public state: State = {
    skip: 0,
    take: 15,
    filter: {
      logic: 'and',
      filters: [],
    },
  }
  groups: GroupDescriptor[]

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups
    this.loadProducts()
  }
  public distinctRole: any[]
  public distinctStatus: any[]
  private loadProducts(): void {
    this.gridDataUserList = process(this.khattaResult, { group: this.groups })
  }
  public gridDataUserList: GridDataResult

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.khattaResult,
    }
    return result
  }

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private routes: ActivatedRoute,
    private broadcaster: Broadcaster,
    private router: Router,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
      this.allData = this.allData.bind(this)
    })

    this.authtoken = JSON.parse(localStorage.getItem('authData'))
    this.routeAccuracy = true
    this.vehicleInfoWindow = new google.maps.InfoWindow()
    this.vehicleInfoWindowClicked = new google.maps.InfoWindow()
    this.value = 300
    this.multiRoute = []
    this.polyline_array = []
    this.secPointMarker = []
    this.vehicleInWard = []
    this.mapLabelArray = []
    this.plotSecondary = false
    this.fuelTypeCount = null
    this.isStats = true
    this.runningVehiclesByType = []
    //this.vehicleCluster  = true
    this.prjID = this.auth.getAuthentication().projectId
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    this.icon = {
      path: car,
      scale: 0.5,
      strokeColor: 'white',
      strokeWeight: 0.1,
      fillOpacity: 1,
      fillColor: '#404040',
      offset: '3%',
      // rotation: parseInt(heading[i]),
      anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    }

    this.controlText = document.createElement('div')
    this.centerControlDiv = document.createElement('div')
    this.centerControlDiv.index = 1
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    this.khattaVehicleID = [
      3445,
      4146,
      646,
      3073,
      3217,
      708,
      659,
      4828,
      3077,
      3084,
      3292,
      4172,
      4121,
      4175,
      4118,
      4333,
      4161,
      4827,
      4104,
    ]

    this.http
      .get(environment.apiUrl + 'entity/get15KhattaPolygons')
      .subscribe((data) => {
        var result: any
        result = data
        this.wardPolygondData = result
      })
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state
    this.gridDataUserList = process(this.khattaResult, this.state)
    if (state && state.group) {
      this.gridDataUserList = process(this.khattaResult, this.state)
      this.distinctStatus = distinctStatus(this.khattaResult)
    }
  }

  getDataWhenProjectChange = async (id) => {
    $('#loderImgTab').show()
    this.loaderService.display(true)
    this.renoveAllMarker()
    let polygon = await fetch(
      environment.apiUrl +
        'entity/getPolygonByOemId' +
        '?prjid=' +
        id +
        '&wardOemId=null' +
        '&beatOemId=null',
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.polygondData = await polygon.json()
    this.clearFeature()
    this.map.data.addGeoJson(this.polygondData.geoJson)
    this.zoom(this.map, true)
    this.setStyle(this)

    let d = await fetch(
      environment.apiUrl +
        'vehicles/getAll?prjId=' +
        this.prjID +
        '&date=' +
        moment(this.date).format('YYYY-MM-DD'),
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.tempVehiclesData = await d.json()
    this.filterVehicles()

    this.plotAllVehicles(this.vehiclesData)
    this.getAllKhatta(id)
    this.loaderService.display(false)

    $('.background').hide()
    $('#loderImgTab').hide()
    $('#progress-bar').hide()
  }

  filterVehicles() {
    for (let i = 0; i < this.tempVehiclesData.liveData.length; i++) {
      for (let j = 0; j < this.khattaVehicleID.length; j++) {
        if (this.tempVehiclesData.liveData[i].id == this.khattaVehicleID[j]) {
          this.vehiclesData.push(this.tempVehiclesData.liveData[i])
        }
      }
    }
  }

  zoomOneEntity(this, map) {
    this.bounds = new google.maps.LatLngBounds()
    map.data.forEach((feature) => {
      if (feature.getProperty('type') == 'clickedPolygon') {
        this.processPoints(
          feature.getGeometry(),
          this.bounds.extend,
          this.bounds,
        )
      }
    })
    map.fitBounds(this.bounds)

    this.map.data.setStyle(function (feature) {
      if (feature.getProperty('type') == 'clickedPolygon') {
        return {
          fillColor: '#666A06',
          strokeColor: '#066A0C',
          strokeWeight: 1,
          fillOpacity: 0.1,
          strokeopacity: 0.1,
        }
      }
    })
  }

  removeEntityPolyGone() {
    this.map.data.forEach((feature) => {
      if (feature.getProperty('type') == 'clickedPolygon') {
        this.map.data.remove(feature)
      }
    })
  }

  liveTrack() {
    if (this.isLive) {
      this.isLive = false
    } else {
      this.renoveAllMarker()
      this.route.setMap(null)
      this.plotRouteWhenLiveTrack()
      this.isLive = true
    }
  }

  deleteMarker(id, mylatlongs, ANGLE) {
    if (this.allMarkers.length > 0) {
      for (var i = 0; i < this.allMarkers.length; i++) {
        if (this.allMarkers[i].id == id) {
          if (this.isLive) {
            var car =
              'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
            var icon = {
              path: car,
              scale: 0.7,
              strokeColor: 'white',
              strokeWeight: 0.11,
              fillOpacity: 1,
              fillColor: '#404040',
              offset: '4%',
              rotation: ANGLE, //<-- Car angle
            }
            this.allMarkers[i].setIcon(icon)
            this.allMarkers[i].setVisible(true)
            this.allMarkers[i].setPosition(mylatlongs)
            // this.plotTransition(this.allMarkers[i], mylatlongs, id)
            //this.allMarkers.splice(i, 1)
          }
          // this.allMarkers[i].setPosition(mylatlongs);
        }
      }
    }
  }

  renoveAllMarker() {
    if (this.allMarkers.length > 0) {
      for (var i = 0; i < this.allMarkers.length; i++) {
        this.allMarkers[i].setVisible(false)
      }
    }
  }

  plotTransition(startMarker, endMarker, id) {
    var last = startMarker.position.lat() + ',' + startMarker.position.lng()
    var first = endMarker.lat() + ',' + endMarker.lng()
    this.http
      .get(
        environment.apiUrl +
          'vehicles/transition' +
          '?first=' +
          last +
          '&last=' +
          first,
      )
      .subscribe((data) => {
        let result: any
        result = data
        this.autoRefreshLiveData(this.map, result.overview_polyline, id)
      })
  }

  plotMarker(point, DEVICEID, DEVICEDATE) {
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    var lineSymbol = {
      path: car,
      scale: 0.7,
      strokeColor: 'white',
      strokeWeight: 0.1,
      fillOpacity: 1,
      fillColor: '#0B0104',
      offset: '5%',
      anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    }
    this.markerStart = new google.maps.Marker({
      position: point,
      map: this.map,
      icon: lineSymbol,
      title: DEVICEID + '(' + DEVICEDATE + ')',
    })
    this.markerStart.id = DEVICEID
    this.markerStart.setMap(this.map)
    this.allMarkers.push(this.markerStart)
  }

  transition(result) {
    var i = 0
    var deltaLat = (result[0] - this.position[0]) / 100
    var deltaLng = (result[1] - this.position[1]) / 100
    this.moveMarker(deltaLat, deltaLng)
  }

  moveMarker(deltaLat, deltaLng) {
    this.position[0] += deltaLat
    this.position[1] += deltaLng
    var latlng = new google.maps.LatLng(this.position[0], this.position[1])
    this.markerStart.setPosition(latlng)
    var i = 0
    if (i != 100) {
      i++
      setTimeout(this.moveMarker, 10)
    }
  }

  plotAllVehicles(data) {
    var locations = []
    var thisRef = this
    var infoWindow = new google.maps.InfoWindow()
    var bounds = new google.maps.LatLngBounds()
    var icon
    var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    if (this.markerCluster) {
      this.markerCluster.clearMarkers()
    }

    this.renoveAllMarker()
    var markers = []
    var color
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    for (var i = 0; i < data.length; i++) {
      if (data[i].LAT && data[i].LONG) {
        var item = data[i]
        if (!item.ANGLE) {
          var rotation = 0
        } else {
          rotation = item.ANGLE
        }

        if (item.OwnerType == 'Contractor') {
          color = '#DF8F1C'
        } else {
          color = '#4AA951'
        }

        icon = {
          path: car,
          scale: 0.7,
          strokeColor: 'black',
          strokeWeight: 1,
          fillOpacity: 1,
          fillColor: color,
          offset: '1%',
          rotation: rotation, //<-- Car angle
        }

        if (item.LAT && item.LONG) {
          if (item.RUNNINGWARD != item.ward) {
            var marker = new google.maps.Marker({
              position: {
                lat: JSON.parse(item.LAT),
                lng: JSON.parse(item.LONG),
              },
              icon: icon,
              label: {
                text: 'X',
                icon: car,
                color: '#D03207',
                fontSize: '16px',
                labelAnchor: new google.maps.Point(25, 65),
                background: 'yellow',
                fontWeight: 'bold',
              },
            })
          } else {
            var marker = new google.maps.Marker({
              position: {
                lat: JSON.parse(item.LAT),
                lng: JSON.parse(item.LONG),
              },
              icon: icon,
            })
          }

          marker.id = item.IMEI
          marker.vehid = item.id
          marker.vehno = item.vehno
          marker.SPEED = item.SPEED
          marker.dateTime = item.HEARTBEATDATE
          marker.type = item.vehtypname
          marker.WARD = item.RUNNINGWARD
          marker.ZONE = item.RUNNINGZONE
          marker.OWNER = item.OwnerType

          marker.assignWard = item.ward

          marker.MIANTSTATUS = item.MIANTSTATUS

          markers.push(marker)
          this.allMarkers.push(marker)
          if (!this.vehicleCluster) {
            marker.setMap(this.map)
          }
        }
        ;(function (marker, data) {
          google.maps.event.addListener(marker, 'click', function (e) {
            thisRef.isClickedVehicle = data.IMEI

            //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
            var content =
              "<div class='col-sm-12 '>" +
              "</p><p class='info-deatil'><strong>Vehicle No:</strong>" +
              '  ' +
              marker.vehno +
              ' ( ' +
              marker.type +
              ' ) ' +
              "</p><p class='info-deatil'><strong>Owner:</strong>" +
              '  ' +
              marker.OwnerType +
              "</p><p class='info-deatil'><strong>Running Ward:</strong>" +
              '  ' +
              marker.assignWard +
              "</p><p class='info-deatil'><strong>Running Ward:</strong>" +
              '  ' +
              marker.WARD +
              "</p><p class='info-deatil'><strong>Status</strong>" +
              '  ' +
              marker.MIANTSTATUS +
              "</p><p class='info-deatil'><strong>Speed:</strong>" +
              '  ' +
              marker.SPEED +
              ' ' +
              'Km/h' +
              "</p><p class='info-deatil'><strong>Last Updated: </strong>" +
              '  ' +
              marker.dateTime +
              ' ' +
              // "</p><p class='info-deatil'><strong>Area :</strong>" + "  " + marker.BEAT + "</p> " +
              '</div>'
            infoWindow.setContent(content)
            infoWindow.open(this.map, marker)
          })
        })(marker, item)
      }
    }
    if (this.vehicleCluster) {
      this.markerCluster = new MarkerClusterer(this.map, markers, {
        imagePath:
          'HttpClient s://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      })
    }
  }

  processPoints(this, geometry, callback, thisArg) {
    if (geometry instanceof google.maps.LatLng) {
      callback.call(thisArg, geometry)
    } else if (geometry instanceof google.maps.Data.Point) {
      callback.call(thisArg, geometry.get())
    } else {
      if (geometry) {
        geometry.getArray().forEach((g) => {
          this.processPoints(g, callback, thisArg)
        })
      }
    }
  }

  zoom(this, map, isZone) {
    this.bounds = new google.maps.LatLngBounds()
    this.map.data.forEach((feature) => {
      if (isZone) {
        this.processPoints(
          feature.getGeometry(),
          this.bounds.extend,
          this.bounds,
        )
      } else {
        if (feature.getProperty('type') == 'route') {
          this.processPoints(
            feature.getGeometry(),
            this.bounds.extend,
            this.bounds,
          )
        }
      }
    })

    map.fitBounds(this.bounds)
  }

  dateChanged() {
    // console.log('fsdjhfdskhfksdhfsdhf');
    //this.getDataWhenProjectChange(this.prjID)
  }

  reload() {
    $('#loderImgTab').hide()
    $('#infotable1').hide()
    $('#infotable2').hide()
    $('#statusTable').show()
    $('#play').show()
    $('#stop').hide()
    $('#veichiclesInfo-bar').hide()
    $('#progress-bar').hide()
    this.removeMultiRoute()
    this.removeLine()
    this.removeMarker()
    this.clearStopMarker()
    //this.getDataWhenProjectChange(this.prjID)
    this.vechicleListIsClicked = false
  }

  removeAssignRoute() {
    this.map.data.forEach((feature) => {
      if (feature.getProperty('Oemid') == 10) {
        this.map.data.remove(feature)
      }
    })
  }

  getAssignroute(id) {
    this.removeAssignRoute()
    this.http
      .get(environment.apiUrl + 'entity/getVehicleroute?' + 'vehId=' + id)
      .subscribe((data) => {
        // console.log(data);
        var result: any
        result = data
        this.map.data.addGeoJson(result.geoJson)
      })
  }

  getAssignSecPoint(id, vehNo) {
    this.http
      .get(environment.apiUrl + 'vehicles/getAssignedSecPoint?' + 'vehId=' + id)
      .subscribe((data) => {
        // console.log('trip', data);
        this.getTripCount(data, vehNo)
      })
  }

  getTripCount(data, vehNo) {
    if (data.length > 0) {
      data[0].vehNo = vehNo
      this.tripData = {}
      let date = moment(this.date).format('YYYY-MM-DD')
      data[0].date = date
      this.http
        .post(environment.apiUrl + 'vehicles/getTrip', data[0])
        .subscribe((data) => {
          // console.log('trip', data);
          this.tripData = data[0]
        })
    } else {
      this.tripData = {}
    }
  }

  createPopupClass() {
    /**
     * A customized popup on the map.
     * @param {!google.maps.LatLng} position
     * @param {!Element} content The bubble div.
     * @constructor
     * @extends {google.maps.OverlayView}
     */
    function Popup(position, content) {
      this.position = position

      content.classList.add('popup-bubble')

      // This zero-height div is positioned at the bottom of the bubble.
      var bubbleAnchor = document.createElement('div')
      bubbleAnchor.classList.add('popup-bubble-anchor')
      bubbleAnchor.appendChild(content)

      // This zero-height div is positioned at the bottom of the tip.
      this.containerDiv = document.createElement('div')
      this.containerDiv.classList.add('popup-container')
      this.containerDiv.appendChild(bubbleAnchor)

      // Optionally stop clicks, etc., from bubbling up to the map.
      google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv)
    }
    // ES5 magic to extend google.maps.OverlayView.
    Popup.prototype = Object.create(google.maps.OverlayView.prototype)

    /** Called when the popup is added to the map. */
    Popup.prototype.onAdd = function () {
      this.getPanes().floatPane.appendChild(this.containerDiv)
    }

    /** Called when the popup is removed from the map. */
    Popup.prototype.onRemove = function () {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv)
      }
    }

    /** Called each frame when the popup needs to draw itself. */
    Popup.prototype.draw = function () {
      var divPosition = this.getProjection().fromLatLngToDivPixel(this.position)

      // Hide the popup when it is far out of view.
      var display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
          ? 'block'
          : 'none'

      if (display === 'block') {
        this.containerDiv.style.left = divPosition.x + 'px'
        this.containerDiv.style.top = divPosition.y + 'px'
      }
      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display
      }
    }

    return Popup
  }

  // optimizeRoute() {
  //     if (this.routeAccuracy) {
  //         this.routeAccuracy = false;
  //     } else {
  //         this.routeAccuracy = true;
  //     }
  //     if (this.vechicleListIsClicked) {
  //     }
  // }

  plotRoute = async (data, index) => {
    // console.log(data);
    if (data.MAINTID == 3) {
      this.isUnderMaintenance = true
    }
    if (data.MAINTID == 1) {
      this.isUnderMaintenance = false
    }
    this.highLightAssignBeat(data.wardid)
    this.getAssignroute(data.id)
    this.getAssignSecPoint(data.id, data.vehno)
    this.loaderService.display(true)
    this.vechicleListIsClicked = true
    this.IEMI = data.IMEI
    this.VEHID = data.id
    this.VEHNO = data.vehno
    this.mobileNo = data.vtsmobileno
    this.servingWardName = ''
    this.assignWard = data.ward
    $('#infotable1').hide()
    $('#infotable2').hide()

    this.clearCurrentVehicalInfo()
    this.renoveAllMarker()
    let date = moment(this.date).format('YYYY-MM-DD')
    this.selectedlist = index
    let response = await fetch(
      environment.apiUrl +
        'vehicles/route' +
        '?DEVICEID=' +
        data.IMEI +
        '&prjId=' +
        this.prjID +
        '&date=' +
        date +
        '&accuracy=true',
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    let result = await response.json()
    this.loaderService.display(false)
    if (result.status == 'No Route Found') {
      this.removeMarker()
      this.getPrevDayLocation(data)
      if (result.data.length > 0) {
        this.showCurrentVehiclesInfo(result.data[0], data)
        this.locateVehicle(result.data[0].STARTPOINT)
        this.plotStartAndEndPoint(result.data[0])
        this.totalStop = 0
        this.totalDuration = 0 + ': ' + 0 + '(hh:mm)'
        $('#infotable1').show()
        $('#infotable2').show()
      } else {
        this.removeMarker()
        $('#infotable1').hide()
        $('#infotable2').hide()
      }

      $('#statusTable').show()
      $('#veichiclesInfo-bar').hide()
      this.clearStopMarker()
      this.removeMultiRoute()
      this.removeLine()
      // alert(result.status);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: result.status,
      })
      return
    } else {
      // $("#statusTable").hide()
      $('#infotable1').show()
      $('#infotable2').show()
      this.removeLine()
      this.removeMultiRoute()
      // this.createRouteChunk(result.path)
      //this.zoomToObject(this.route)
      this.createRoute(this.map, result.latLong)

      this.showCurrentVehiclesInfo(result, data)
      this.removeMarker()
      this.plotStartAndEndPoint(result)

      let stopInfo = await fetch(
        environment.apiUrl +
          'getStopInfo?DEVICEID=' +
          data.IMEI +
          '&DEVICEDATE=' +
          date,
        {
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: this.authtoken.token,
          },
        },
      )
      let stop_info_data = await stopInfo.json()
      this.plotStopPosition(stop_info_data)

      let res = await fetch(
        environment.apiUrl +
          'vehicles/getServingArea' +
          '?DEVICEID=' +
          data.IMEI +
          '&prjId=' +
          this.prjID +
          '&date=' +
          date,
        {
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: this.authtoken.token,
          },
        },
      )
      var servingWard = await res.json()
      this.servingWardName = servingWard.wardName
    }
  }

  getPrevDayLocation = async (data) => {
    let res = await fetch(
      environment.apiUrl +
        'vehicles/getPrevDayLocation' +
        '?DEVICEID=' +
        data.IMEI +
        '&prjId=' +
        this.prjID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    var lastActive = await res.json()
    if (lastActive.length > 0) {
      $('#infotable1').show()
      $('#infotable2').show()
      this.distance = 0
      this.vehiclesNo = data.vehno
      this.vehiclesType = data.vehtypname
      this.startTime = 'NA'
      this.endTime = 'NA'
      this.totalStop = 0
      this.totalDuration = 0
      this.lastActiveTime = moment(new Date(lastActive[0].lastActiveDate))
        .startOf('hour')
        .fromNow()
      var latlng = {
        lat: lastActive[0].lastLocation.coordinates[1],
        lng: lastActive[0].lastLocation.coordinates[0],
      }
      this.geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK') {
          this.currentAddress = results[0].formatted_address
        }
      })

      var start = new google.maps.LatLng(
        lastActive[0].lastLocation.coordinates[1],
        lastActive[0].lastLocation.coordinates[0],
      )
      this.markerStart = new google.maps.Marker({
        position: start,
        map: this.map,
        icon: 'assets/img/start.png',
        labelClass: 'labels', // the CSS class for the label
        labelStyle: { opacity: 1.0 },
      })
      var position = {
        LAT: lastActive[0].lastLocation.coordinates[1],
        LONG: lastActive[0].lastLocation.coordinates[0],
      }
      this.locateVehicle(position)
    }
  }

  closeInfo() {
    $('.individual_detail').slideToggle()
    $('.fa-chevron-left').toggleClass('fa-chevron-right')
  }
  getGeoLocation(lat, LONG, i, data) {
    var latlng = { lat: lat, lng: LONG }
    this.geocoder.geocode(
      { location: latlng, result_type: 'street_address' },
      (results, status) => {
        if (status === 'OK') {
          var result = results[0].formatted_address
          var address =
            result.split(',')[0] +
            ' ' +
            result.split(',')[1] +
            +' ' +
            result.split(',')[2]
          this.stopSummary[i].address = address
        }
      },
    )
  }
  getStopSummary() {
    this.isCustomLoading = true
    $('#stopSummary').modal('show')
    let date = moment(this.date).format('YYYY-MM-DD')
    this.http
      .get(
        environment.apiUrl +
          'vehicle/stopSummary?' +
          'prjId=' +
          this.prjID +
          '&deviceId=' +
          this.IEMI +
          '&date=' +
          date,
      )
      .subscribe((data) => {
        this.stopSummary = data
        this.getTotalStopsInBeat(this.stopSummary)
        this.isCustomLoading = false
      })
  }

  printPdf(): void {
    let printContents, popupWin
    printContents = document.getElementById('print-section').innerHTML

    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto')
    popupWin.document.open()
    popupWin.document.write(`
      <html>
        <head>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`)
    popupWin.document.close()
  }
  getTotalStopsInBeat(data) {
    var stop = 0
    for (var i = 0; i < data.length; i++) {
      stop = stop + data[i].totalStops
    }
    this.totalStopBeat = stop
  }

  getTrip(imei) {
    this.http
      .get(environment.apiUrl + 'vehicles/getTrip' + '?imei=' + imei)
      .subscribe((data) => {
        let result = data
      })
  }

  async getEngineOffLocation(IMEI, date) {
    let engineOff = await fetch(
      environment.apiUrl +
        'getEngineOffLocation?DEVICEID=' +
        IMEI +
        '&DEVICEDATE=' +
        date,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    let engineOffData = await engineOff.json()
    this.plotEngineOffLocation(engineOffData)
  }

  getAllKhatta(prjID) {
    this.http
      .get(environment.apiUrl + 'admin/get15KhattaDetails' + '?PRJID=' + prjID)
      .subscribe((data) => {
        let result: any
        result = data
        this.secondaryPointData = result
        //this.plotAllKhatta(result)
      })
  }

  downloadReport() {
    console.log('this.date', this.date)

    var startDate = moment(this.date).format('YYYY-MM-DD')
    // var endDate = moment(new Date()).add(1, 'days').format("YYYY-MM-DD");
    window.open(
      environment.apiUrl +
        'vehicle/khattaSummary?' +
        'prjId=' +
        this.prjID +
        '&date=' +
        startDate,
    )
  }

  downloadVehicleReport() {
    var startDate = moment(this.date).format('YYYY-MM-DD')
    // var endDate = moment(new Date()).add(1, 'days').format("YYYY-MM-DD");
    // window.open(
    //   environment.apiUrl +
    //     'vehicle/vehKhattaSummary?' +
    //     'prjId=' +
    //     this.prjID +
    //     '&date=' +
    //     startDate,
    // )

    this.http
      .get(
        environment.apiUrl +
          'vehicle/vehKhattaSummary?' +
          'prjId=' +
          this.prjID +
          '&date=' +
          startDate,
      )
      .subscribe((data) => {
        this.khattaResult = data
        console.log('result', this.khattaResult)

        this.gridDataUserList = process(this.khattaResult, this.state)
      })
  }

  khattadateChanged() {
    this.downloadVehicleReport()
  }

  viewVehicleReport() {
    console.log('viewVehicleReport')

    var startDate = moment(this.date).format('YYYY-MM-DD')
    // var endDate = moment(new Date()).add(1, 'days').format("YYYY-MM-DD");

    this.http
      .get(
        environment.apiUrl +
          'vehicle/viewVehicleReport?' +
          'prjId=' +
          this.prjID +
          '&date=' +
          startDate,
      )
      .subscribe((data) => {
        this.routesData = data

        console.log(this.routesData, 'this.routesData')
      })
  }

  plotKhattaLoc() {
    this.plotKhattaPoint = this.plotKhattaPoint ? false : true
    if (this.plotKhattaPoint) {
      this.plotNewKhattaLoc(this.secondaryPointData)
    } else {
      this.removeSecPoint()
    }
  }

  removeSecPoint() {
    if (this.secPointMarker.length > 0) {
      for (var i = 0; i < this.secPointMarker.length; i++) {
        this.secPointMarker[i].setVisible(false)
      }
    }
  }

  searchMarkerLocation(event: any, type) {
    // without type info
    let values: any
    values = event.target.value
    if (values) {
      if (values.length >= 4) {
        if (type == 'veh') {
          this.vehiclesData.forEach((e) => {
            if (e.vehno.includes(values)) {
              this.removeNonSearachedMarkers(e.id, type)
            }
          })
        } else {
          this.secondaryPointData.forEach((e) => {
            if (e.ENTITYNAME.includes(values)) {
              this.removeNonSearachedMarkers(e.ID, type)
            }
          })
        }
      }
    }
    if (values == '' || values.length < 4) {
      // this.plotAllVehicles(this.tempVehiclesData);
      for (var i = 0; i < this.allMarkers.length; i++) {
        this.allMarkers[i].setVisible(true)
      }
      for (var i = 0; i < this.secPointMarker.length; i++) {
        this.secPointMarker[i].setVisible(true)
      }
    }
  }

  removeNonSearachedMarkers(id, type) {
    if (type == 'veh') {
      if (this.allMarkers.length > 0) {
        for (var i = 0; i < this.allMarkers.length; i++) {
          if (this.allMarkers[i].vehid != id) {
            this.allMarkers[i].setVisible(false)
          }
        }
      }
    } else {
      if (this.secPointMarker.length > 0) {
        for (var i = 0; i < this.secPointMarker.length; i++) {
          if (this.secPointMarker[i].ID != id) {
            this.secPointMarker[i].setVisible(false)
          }
        }
      }
    }
  }
  // removeSecPoint(id) {
  //     if (this.secPointMarker.length > 0) {
  //         for (var i = 0; i < this.secPointMarker.length; i++) {
  //             if (this.secPointMarker[i].OEMID == id) {
  //                 this.secPointMarker[i].setVisible(false);
  //             }
  //         }
  //     }
  // }

  async plotWardBoundary() {
    this.wardBoundary = this.wardBoundary ? false : true
    var khattaLatLng = []

    this.loaderService.display(true)
    if (!this.wardBoundary) {
      this.map.data.forEach((feature) => {
        console.log(feature.getProperty('TYPE'))
        if (feature.getProperty('TYPE') != 'stopMarker') {
          this.map.data.remove(feature)
          this.removeMapLabel(feature.getProperty('EntityID'))
        }
      })
      this.loaderService.display(false)
    } else {
      this.map.data.addGeoJson(this.wardPolygondData.geoJson)
      for (let i = 0; i < this.wardPolygondData.entityData.length; i++) {
        var kml = { coordinates: [] }
        var latLngObj = { LAT: 0, LNG: 0, ID: 0, ENTITYNAME: '', OEMNAME: '' }

        kml = JSON.parse(this.wardPolygondData.entityData[i].kml)
        latLngObj.LNG = kml.coordinates[0][0][0]
        latLngObj.LAT = kml.coordinates[0][0][1]
        latLngObj.ID = this.wardPolygondData.entityData[i].id
        latLngObj.ENTITYNAME = this.wardPolygondData.entityData[i].entityname
        latLngObj.OEMNAME = this.wardPolygondData.entityData[i].entitycd
        khattaLatLng.push(latLngObj)
      }
      this.plotNewKhattaLoc(khattaLatLng)
      this.secondaryPointData = khattaLatLng
      this.loaderService.display(false)
    }
  }

  plotNewKhattaLoc(data) {
    var markers = []
    var icon = 'assets/img/khatta.png'
    var marker
    for (var i = 0; i < data.length; i++) {
      var item = data[i]
      if (item.LAT != null && item.LNG != null) {
        icon = 'assets/img/khatta.png'
        marker = new google.maps.Marker({
          position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
          map: this.map,
          icon: icon,
          title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
          OEMID: data[i].OEMID,
          ID: item.ID,
        })
        this.secPointMarker.push(marker)
        marker.setMap(this.map)
        if (item) {
          marker.OEMNAME = item.OEMNAME
          marker.LAT = item.LAT
          marker.LNG = item.LNG
          marker.ENTITYNAME = item.ENTITYNAME
          markers.push(marker)
        }
      }
      ;(function (marker, data, thisRef) {
        var position = { lat: marker.LAT, lng: marker.LNG }
        google.maps.event.addListener(marker, 'click', function (e) {
          thisRef.http
            .post(environment.apiUrl + 'entity/getEntityByPoint', position)
            .subscribe((data) => {
              var entity = data[0]
              var content =
                "<div class='col-sm-12 '>" +
                "<p class='info-deatil'><strong>Name:</strong>" +
                '  ' +
                marker.ENTITYNAME +
                "</p><p class='info-deatil'><strong>Type</strong>" +
                '  ' +
                marker.OEMNAME +
                "</p><p class='info-deatil'><strong>Position</strong>" +
                '  ' +
                marker.LAT +
                ',' +
                marker.LNG +
                "</p><p class='info-deatil'><strong>Zone</strong>" +
                '  ' +
                entity.zoneName +
                "</p><p class='info-deatil'><strong>Ward</strong>" +
                '  ' +
                entity.WardName +
                '</div>'
              var infoWindow = new google.maps.InfoWindow()
              infoWindow.setContent(content)
              infoWindow.open(this.map, marker)
            })
        })
      })(marker, item, this)
    }
  }

  plotEngineOffLocation(engineOffData) {
    //this.clearStopMarker()
    var data = { features: [], type: '' }
    data.type = 'FeatureCollection'
    var coordinates = []
    var stop = 0
    var totalDuration = 0
    for (var i = 0; i < engineOffData.length; i++) {
      if (engineOffData[i].LONG && engineOffData[i].LAT) {
        stop++
        var geometry = { coordinates: [], type: '' }
        geometry.coordinates.push(
          Number(engineOffData[i].LONG),
          Number(engineOffData[i].LAT),
        )
        geometry.type = 'Point'
        // var duration =  this.diff_hours(new Date(engineOffData[i].STARTTIME), new Date(engineOffData[i].ENDTIME))
        totalDuration = totalDuration + engineOffData[i].duration
        data.features.push({
          geometry: geometry,
          type: 'Feature',
          properties: {
            ZONE: engineOffData[i].zoneName,
            WARD: engineOffData[i].WardName,
            TYPE: 'engine_Off',
            STARTTIME: engineOffData[i].HEARTBEATDATE,
          },
        })
      }
    }
    this.map.data.addGeoJson(data)
  }
  drivingSummaryModal() {
    $('#drivingSummary').modal('show')
  }

  diff_hours(dt2, dt1) {
    var difference = dt1.getTime() - dt2.getTime() // This will give difference in milliseconds
    var resultInMinutes = Math.round(difference / 60000)
    var hours = resultInMinutes / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.round(minutes)
    return rhours + ': ' + rminutes
  }

  diff_minutes(dt2, dt1) {
    var difference = dt1.getTime() - dt2.getTime() // This will give difference in milliseconds
    var resultInMinutes = Math.round(difference / 60000)
    var hours = resultInMinutes / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.round(minutes)
    return rminutes
  }

  plotStopPosition(stopInfo) {
    this.clearStopMarker()
    var data = { features: [], type: '' }
    data.type = 'FeatureCollection'
    var coordinates = []
    var stop = 0
    var totalDuration = 0
    for (var i = 0; i < stopInfo.length; i++) {
      if (stopInfo[i].LONG && stopInfo[i].LAT) {
        stop++
        var geometry = { coordinates: [], type: '' }
        geometry.coordinates.push(
          Number(stopInfo[i].LONG),
          Number(stopInfo[i].LAT),
        )
        geometry.type = 'Point'
        var duration = this.diff_hours(
          new Date(stopInfo[i].STARTTIME),
          new Date(stopInfo[i].ENDTIME),
        )
        var difInMinutes = this.diff_minutes(
          new Date(stopInfo[i].STARTTIME),
          new Date(stopInfo[i].ENDTIME),
        )
        // console.log('difInMinutes', difInMinutes);
        totalDuration = totalDuration + stopInfo[i].duration
        data.features.push({
          geometry: geometry,
          type: 'Feature',
          properties: {
            DEVICEID: stopInfo[i].DEVICEID,
            VEHICLE_NO: stopInfo[i].VEHICLE_NO,
            STARTTIME: stopInfo[i].STARTTIME,
            ENDTIME: stopInfo[i].ENDTIME,
            DURATION: duration,
            difInMinutes: difInMinutes,
            ZONE: stopInfo[i].zoneName,
            WARD: stopInfo[i].WardName,
            BEAT: stopInfo[i].beatName,
            TYPE: 'stopMarker',
            engineStatus: stopInfo[i].ACC == 0 ? 'Off' : 'On',
            number: stop,
          },
        })
      }
    }
    this.totalStop = stop
    var hours = totalDuration / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.round(minutes)
    this.totalDuration = rhours + ': ' + rminutes + '(hh:mm)'
    this.map.data.addGeoJson(data)
  }

  makeRoute(polyCords) {
    this.routePath = polyCords
    var lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      fillColor: '#121C11',
      offset: '2%',
    }
    this.route = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#121C11',
      strokeOpacity: 3.0,
      strokeWeight: 3,
      icons: [
        {
          icon: lineSymbol,
          offset: '100%',
        },
      ],
      map: this.map,
    })
  }
  createRouteChunk(coordinates) {
    this.multiRoute = []
    var lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      fillColor: '#D8E20F',
      offset: '2%',
    }
    var chunk_size = 10
    var coords = []
    var arrayLength = coordinates.length
    for (var index = 0; index < arrayLength; index += chunk_size) {
      var myChunk = coordinates.slice(index, index + chunk_size)
      for (var i = 0; i < myChunk.length; i++) {
        coords.push({ lat: myChunk[i].LAT, lng: myChunk[i].LONG })
      }

      var route = new google.maps.Polyline({
        path: coords,
        strokeColor: '#121C11',
        strokeOpacity: 3.0,
        strokeWeight: 3,
        icons: [
          {
            icon: lineSymbol,
            offset: '100%',
          },
        ],
        map: this.map,
      })

      this.multiRoute.push(route)

      //this.makeRoute(coords);
      coords = []
    }
    this.plotMultiRoute()
  }

  plotMultiRoute() {
    for (var i = 0; i < this.multiRoute.length; i++) {
      this.multiRoute[i].setMap(true)
    }
  }

  removeMultiRoute() {
    if (this.multiRoute.length > 0) {
      for (var i = 0; i < this.multiRoute.length; i++) {
        this.multiRoute[i].setMap(null)
      }
    }
  }

  plotRouteWhenLiveTrack() {
    this.route = new google.maps.Polyline({
      path: this.routePath,
      strokeColor: '#686C55',
      strokeOpacity: 1.0,
      strokeWeight: 3,
      map: this.map,
    })
  }
  createRoute(map, pathCoords) {
    var i, route, marker
    var polyCords = []
    for (i = 0; i < pathCoords.length; i++) {
      polyCords.push({
        lat: JSON.parse(pathCoords[i][1]),
        lng: JSON.parse(pathCoords[i][0]),
      })
    }
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    var icon = {
      path: car,
      scale: 1,
      strokeColor: 'white',
      strokeWeight: 0.1,
      fillOpacity: 5,
      fillColor: '#35370C',
      offset: '2%',
      // rotation: parseInt(heading[i]),
      anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    }
    this.routePath = polyCords
    this.route = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#E2EF16',
      strokeOpacity: 4.0,
      strokeWeight: 5,
      icons: [
        {
          icon: icon,
          offset: '100%',
        },
      ],
      map: map,
    })
    this.zoomToObject(this.route)
  }

  clearCurrentVehicalInfo() {
    this.distance = null
    this.vehiclesNo = null
    this.IMEI = null
    this.vehiclesType = null
    this.startTime = null
    this.endTime = null
    this.currentAddress = null
  }
  vehiclelist() {
    $('.individual_box').show()
    $('#vehicleList').show()
    $('.vehiclelistbox').show()
  }
  closeVehicle() {
    $('.vehiclelistbox').slideToggle()
    $('.fa-chevron-left').toggleClass('fa-chevron-right')
  }
  showCurrentVehiclesInfo(data, tableRow) {
    this.beatName = data.END_BEATNAME
    this.distance = data.distance.toFixed(2)
    this.vehiclesNo = tableRow.vehno
    this.IMEI = tableRow.IMEI
    this.vehiclesType = tableRow.vehtypname
    this.startTime = moment(new Date(data.STARTTIME)).format('h:mm:ss a')
    this.endTime = moment(new Date(data.ENDTIME)).format('h:mm:ss a')
    this.lastActiveTime = tableRow.HEARTBEATDATE
    var latlng = { lat: data.ENDPOINT.LAT, lng: data.ENDPOINT.LONG }
    this.geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK') {
        this.currentAddress = results[0].formatted_address
      }
    })

    var latlngStart = { lat: data.STARTPOINT.LAT, lng: data.STARTPOINT.LONG }

    this.geocoder.geocode({ location: latlngStart }, (results, status) => {
      if (status === 'OK') {
        this.currentAddressStart = results[0].formatted_address
      }
    })
  }
  removeLine() {
    if (this.route) {
      this.route.setMap(null)
    }
  }
  removeMarker() {
    if (this.markerStart && this.markerEnd) {
      this.markerStart.setMap(null)
      this.markerEnd.setMap(null)
    } else if (this.markerStart) {
      this.markerStart.setMap(null)
    }
  }

  removeClickedMarker() {
    if (this.clickedMarker) {
      this.clickedMarker.setMap(null)
    }
  }
  removeStartAndEndPoint() {
    this.infoWindowStart.close()
    this.infoWindowEnd.close()
  }
  StatusUp() {
    $('.status_extra').slideToggle()
    $('.fa-chevron-down').toggleClass('fa-chevron-up')
  }
  plotStartAndEndPoint(data) {
    var start = new google.maps.LatLng(
      data.STARTPOINT.LAT,
      data.STARTPOINT.LONG,
    )
    var end = new google.maps.LatLng(data.ENDPOINT.LAT, data.ENDPOINT.LONG)
    this.markerStart = new google.maps.Marker({
      position: start,
      map: this.map,
      icon: 'assets/img/start.png',

      labelClass: 'labels', // the CSS class for the label
      labelStyle: { opacity: 1.0 },
    })
    this.markerEnd = new google.maps.Marker({
      position: end,
      map: this.map,
      icon: 'assets/img/end.png',
    })
  }

  autoRefreshLiveData(map, pathCoords, id) {
    var i, route, marker
    var polyCords = []
    var polyLiveCords = []
    this.removePolyLine(id)
    for (i = 0; i < pathCoords.length; i++) {
      polyCords.push({
        lat: JSON.parse(pathCoords[i][1]),
        lng: JSON.parse(pathCoords[i][0]),
      })
      //  this.routePath.push({ lat: JSON.parse(pathCoords[i][1]), lng: JSON.parse(pathCoords[i][0]) })
    }
    // if(this.live){
    //   this.plotLiveRoute(pathCoords)
    // }

    this.Liveroute = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#686C55',
      strokeOpacity: 1.0,
      strokeWeight: 4,
      icons: [
        {
          icon: this.icon,
          offset: '100%',
        },
      ],
      map: this.map,
    })
    this.polyline_array.push({ line: this.Liveroute, id: id })
    // this.animateCircle(this.Liveroute)
    var markerPoint = pathCoords[0]
    polyCords = []
  }

  plotLiveRoute(polyCords) {
    this.route = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#686C55',
      strokeOpacity: 1.0,
      strokeWeight: 4,
      icons: [
        {
          icon: this.icon,
          offset: '100%',
        },
      ],
      map: this.map,
    })
  }
  removePolyLine(id) {
    for (var i = 0; i < this.polyline_array.length; i++) {
      if (id == this.polyline_array[i].id) {
        this.polyline_array[i].line.setMap(null)
      }
    }
  }

  animateLiveCircle(line) {
    var count = 0
    var value = 300
    stopAnimation = true
    var myinterval = setInterval(() => {
      count = (count + 1) % 200
      var icons = line.get('icons')
      icons[0].offset = count / 2 + '%'
      if (count === 199) {
        line.set('icons', null)
        clearInterval(myinterval)
        //line.unSet('icons', icons);
        line.setMap(null)
      }
      line.set('icons', icons)
    }, 250)
  }

  animateCircle(line) {
    var count = 0
    $('#play').hide()
    $('#stop').show()
    if (!stopAnimation) {
      stopAnimation = true
      return
    }
    stopAnimation = true
    var myVar = window.setInterval(function () {
      if (stopAnimation) {
        count = (count + 1) % 200
        var icons = line.get('icons')
        icons[0].offset = count / 2 + '%'
        if (count === 199) {
          clearInterval(myVar)
          $('#play').show()
          $('#stop').hide()
        }
        line.set('icons', icons)
      }
    }, 150)
  }

  async refreshLiveData() {
    let vehicles = await fetch(
      environment.apiUrl + 'vehicles/location/all' + '?prjID=' + this.prjID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.vehiclesLocation = await vehicles.json()
    this.plotAllVehicles(this.vehiclesLocation)
  }
  stopPlay() {
    stopAnimation = false
    $('#play').show()
    $('#stop').hide()
  }
  zoomToObject(obj) {
    var bounds = new google.maps.LatLngBounds()
    var points = obj.getPath().getArray()
    for (var n = 0; n < points.length; n++) {
      bounds.extend(points[n])
    }
    this.map.fitBounds(bounds)
  }

  clearFeature() {
    this.map.data.forEach((feature) => {
      this.map.data.remove(feature)
    })
  }
  removeMapLabel(entityId) {
    for (var i = 0; i < this.mapLabelArray.length; i++) {
      if (entityId == this.mapLabelArray[i].entityId) {
        this.mapLabelArray[i].setMap(null)
      }
    }
  }

  clearPrevRoute(data) {
    this.map.data.forEach((feature) => {
      if (feature.getProperty('type') == 'route') {
        this.map.data.remove(feature)
      }
    })
  }

  clearStopMarker() {
    this.map.data.forEach((feature) => {
      if (
        feature.getProperty('TYPE') == 'stopMarker' ||
        feature.getProperty('TYPE') == 'engine_Off'
      ) {
        this.map.data.remove(feature)
      }
    })
  }

  highLightAssignBeat(entityId) {
    this.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor')
      var strokeColor = feature.getProperty('Bcolor')
      if (feature.getProperty('EntityID') == entityId) {
        return {
          fillColor: '#3E0560',
          strokeColor: '#3E0560',
          strokeWeight: 2,
          fillOpacity: 0.5,
          strokeopacity: 0.4,
        }
      } else if (feature.getProperty('TYPE') == 'stopMarker') {
        if (feature.getProperty('difInMinutes') > 20) {
          var icon = 'assets/img/delayStop.png'
        } else {
          var icon = 'assets/img/stopMarker.png'
        }
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 2,
          fillOpacity: 0.05,
          icon: icon,
          strokeopacity: 0.2,
          label: {
            text: feature.getProperty('number'),
            color: '#FFFFFF',
            fontSize: '13px',
            background: 'yellow',
            fontWeight: 'bold',
            AlignmentVertical: 'top',
            AlignmentHorizontal: 'center',
          },
          labelClass: 'my-custom-class-for-label',
        }
      } else if (feature.getProperty('TYPE') == 'khatta') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 5,
          fillOpacity: 0.0,
          strokeopacity: 0.2,
          icon: 'assets/img/khatta.png',
        }
      } else if (
        feature.getProperty('Oemid') == 8 ||
        feature.getProperty('Oemid') == 9 ||
        feature.getProperty('Oemid') == 10 ||
        feature.getProperty('Oemid') == undefined
      ) {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 3,
          fillOpacity: 0.1,
          strokeopacity: 0.8,
        }
      } else {
        return {
          fillColor: color,
          strokeColor: '#040C0A',
          strokeWeight: 4,
          fillOpacity: 0.1,
          strokeopacity: 0.4,
        }
      }
    })
  }
  setStyle(thisRef) {
    this.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor')
      var strokeColor = feature.getProperty('Bcolor')
      var strokeOpacity = feature.getProperty('stroke-opacity')
      if (feature.getProperty('Oemid') == 8) {
        thisRef.polygonLabel(
          feature.getProperty('Ward'),
          feature.getProperty('LAT'),
          feature.getProperty('LON'),
          16,
          12,
          feature.getProperty('EntityID'),
          strokeColor,
        )
      } else if (feature.getProperty('Oemid') == 7) {
        thisRef.polygonLabel(
          feature.getProperty('Zone'),
          feature.getProperty('LAT'),
          feature.getProperty('LON'),
          18,
          13,
          feature.getProperty('EntityID'),
          '#010100',
        )
      }
      // else if(feature.getProperty('Oemid') == 9){
      //   thisRef.polygonLabel(feature.getProperty('Beat'),feature.getProperty('LAT'),feature.getProperty('LON'))
      // }

      if (feature.getProperty('TYPE') == 'stopMarker') {
        if (feature.getProperty('difInMinutes') > 20) {
          var icon = 'assets/img/delayStop.png'
        } else {
          var icon = 'assets/img/stopMarker.png'
        }
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 2,
          fillOpacity: 0.05,
          icon: icon,
          strokeopacity: 0.2,
          label: {
            text: feature.getProperty('number'),
            color: '#FFFFFF',
            fontSize: '13px',
            background: 'yellow',
            fontWeight: 'bold',
            AlignmentVertical: 'top',
            AlignmentHorizontal: 'center',
          },
          labelClass: 'my-custom-class-for-label',
        }
      } else if (feature.getProperty('TYPE') == 'khatta') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 5,
          fillOpacity: 0.0,
          strokeopacity: 0.2,
          icon: 'assets/img/khatta.png',
        }
      } else if (
        feature.getProperty('Oemid') == 8 ||
        feature.getProperty('Oemid') == 9 ||
        feature.getProperty('Oemid') == 10 ||
        feature.getProperty('Oemid') == undefined
      ) {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 3,
          fillOpacity: 0.1,
          strokeopacity: 0.8,
        }
      } else {
        return {
          fillColor: color,
          strokeColor: '#040C0A',
          strokeWeight: 4,
          fillOpacity: 0.1,
          strokeopacity: 0.4,
        }
      }
    })
  }

  /* 
     excel Import
  */

  s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }
  importToExcel(data) {
    const ws_name = 'SomeSheet'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(data)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary',
    })
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'VehicleList.xlsx',
    )
  }

  async refreshCount(id) {
    //git this.renoveAllMarker()
    let d = await fetch(
      environment.apiUrl +
        'vehicles/getAll?prjId=' +
        this.prjID +
        '&date=' +
        moment(this.date).format('YYYY-MM-DD'),
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.tempVehiclesData = await d.json()
    this.filterVehicles()
  }

  locateVehicle(position) {
    var myPlace = new google.maps.LatLng(position.LAT, position.LONG)
    var bounds = new google.maps.LatLngBounds(myPlace)
    this.map.fitBounds(bounds)
  }

  runningVehicleByType() {
    // Set CSS for the control border.
    var thisRef = this
    var controlDiv = document.createElement('div')
    var controlUI = document.createElement('div')
    controlUI.style.backgroundColor = '#fff'
    controlUI.style.border = '2px solid #fff'
    controlUI.style.borderRadius = '2px'
    controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
    controlUI.style.cursor = 'pointer'
    controlUI.style.margin = '10px'

    controlUI.style.textAlign = 'center'
    controlUI.title = 'STATS'
    controlDiv.appendChild(controlUI)

    // Set CSS for the control interior.
    var controlText = document.createElement('div')
    controlText.style.color = 'rgb(25,25,25)'
    //            controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
    //            controlText.style.fontSize = '13px';
    controlText.style.fontWeight = 'bold'
    controlText.style.lineHeight = '25px'

    controlText.innerHTML = 'STATS'
    controlText.className = 'gm-style-mtc'
    controlText.style.paddingLeft = '5px'
    controlText.style.paddingRight = '5px'
    controlUI.appendChild(controlText)

    controlUI.addEventListener('click', function () {
      $('#divwastedate').slideToggle()
      $('#divvehicledate').slideToggle()
      thisRef.isStats = true
      if (thisRef.isStats == false) {
        thisRef.isStats = true
        $('#divVehcile1').css('top', '-439px')
        $('#divVehcile2').css('top', '-439px')
      } else {
        thisRef.isStats = false
        $('#divVehcile1').css('top', '-140px')
        $('#divVehcile2').css('top', '-140px')
      }
    })
  }

  vehicleStatControl() {
    var htmlString =
      "<table class=\"table-bordered\"><tr><td align='center' colspan='3'><b>Vehicle Details</b></td></tr><tr><td align='left'><b>Type</b></td><td align='right'><b>Total</b></td><td align='right'><b>In Working</b></td></tr>"
    for (var i = 0; i < this.runningVehiclesByType.length; i++) {
      htmlString =
        htmlString +
        '<tr><td><b>' +
        this.runningVehiclesByType[i].type +
        "</b></td><td style='text-align:right'><b>" +
        this.runningVehiclesByType[i].total +
        "</b></td><td style='text-align:right'><b>" +
        this.runningVehiclesByType[i].active +
        '</b></td></tr> '
    }

    htmlString =
      htmlString +
      '<tr><td><b>' +
      "</b></td><td style='text-align:right'><b>" +
      this.totalAvilable +
      "</b></td><td style='text-align:right'><b>" +
      this.totalWorking +
      '</b></td></tr> '
    if (htmlString != '') {
      htmlString = htmlString + '</table>'
      $('#divvehicledate').append(htmlString)
    }
  }

  polygonLabel(text, lat, long, strokeWeight, fontSize, entityId, color) {
    var myLatlng = new google.maps.LatLng(Number(lat), Number(long))
    var mapLabel = new MapLabel({
      text: text,
      position: myLatlng,
      map: this.map,
      strokeWeight: strokeWeight,
      fontSize: fontSize,
      align: 'left',
      entityId: entityId,
      fontColor: color,
    })
    this.mapLabelArray.push(mapLabel)
    mapLabel.set('position', myLatlng)
  }

  statusColor() {
    // console.log('fddsfs');

    return 'vehicle-box vts_installed_border'
  }

  closeMapInfo() {
    $('.map-info-window').hide()
  }
  ngOnInit() {
    $('.map-info-window').hide()

    $('#drivingSummary').modal('hide')
    //this.getDataWhenProjectChange(this.prjID)

    this.viewVehicleReport()

    this.downloadVehicleReport()

    if (this.prjID == 1) {
      this.isLko = true
    }

    // this.getWardPolygon();
    this.vehiclelist()
    var thisRef = this

    $('#infotable1').hide()
    $('#infotable2').hide()
    $('#statusTable').show()
    $('#play').show()
    $('#stop').hide()
    $('#veichiclesInfo-bar').hide()
    $('#progress-bar').hide()
    this.geocoder = new google.maps.Geocoder()
    var myOptions = {
      center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
      zoom: 13,

      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_CENTER,
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_LEFT,
      },
      scaleControl: true,

      fullscreenControl: true,
    }

    this.map = new google.maps.Map(document.getElementById('map'), myOptions)
    // var trafficLayer = new google.maps.TrafficLayer();
    // trafficLayer.setMap(this.map);
    var config = {
      authDomain: 'ecogreen-citizen-app.firebaseapp.com',
      apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
      databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
      storageBucket: 'ecogreen-citizen-app.appspot.com',
      projectId: 'ecogreen-citizen-app',
    }

    var infoWindow = new google.maps.InfoWindow()
    this.map.data.addListener('click', showArrays)
    function showArrays(event) {
      if (event.feature.getProperty('TYPE') == 'stopMarker') {
        var position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
        var content =
          "<div class='col-sm-12'>" +
          "<p class='info-deatil'><strong>Entry Time :</strong>" +
          '  ' +
          event.feature.getProperty('STARTTIME') +
          "</p><p class='info-deatil'><strong>Exit Time :</strong>" +
          '  ' +
          event.feature.getProperty('ENDTIME') +
          "</p><p class='info-deatil'><strong>Duration :</strong>" +
          '  ' +
          event.feature.getProperty('DURATION') +
          ' ' +
          "</p><p class='info-deatil'><strong>Ward :</strong>" +
          '  ' +
          event.feature.getProperty('WARD') +
          ' ' +
          "</p><p class='info-deatil'><strong>Engine :</strong>" +
          '  ' +
          event.feature.getProperty('engineStatus') +
          '</p></div>'
        infoWindow = new google.maps.InfoWindow({
          content: content,
          position: position,
        })

        google.maps.InfoWindowOptions
        infoWindow.open(this.map)
      } else {
        var position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
        if (this.zoneWardInfoWindow) {
          this.zoneWardInfoWindow.close()
        }

        thisRef.removeClickedMarker()

        var clickedPoint = new google.maps.LatLng(
          event.latLng.lat(),
          event.latLng.lng(),
        )

        thisRef.clickedMarker = new google.maps.Marker({
          position: clickedPoint,
          map: thisRef.map,
          icon: 'assets/img/clickedMarker.png',
          labelClass: 'labels', // the CSS class for the label
          labelStyle: { opacity: 1.0 },
        })
        $('.map-info-window').show()

        $('#zoneInfo_Window').hide()
        $('#zone_loader').show()
        thisRef.http
          .post(environment.apiUrl + 'entity/getEntityByPoint', position)
          .subscribe((data) => {
            thisRef.clickedEntity = data[0]
            thisRef.geocoder.geocode(
              { location: clickedPoint },
              (results, status) => {
                if (status === 'OK') {
                  thisRef.clickedEntity.currentAddress =
                    results[0].formatted_address
                }
              },
            )
            $('#zone_loader').hide()
            $('#zoneInfo_Window').show()
          })
      }
    }
    firebase.initializeApp(config)

    var listRef = firebase.database().ref('/')
    listRef.on('child_changed', (dataSnapshot) => {
      const msg = dataSnapshot.val()
      var newPosition = dataSnapshot.val()
      var mylatlongs = new google.maps.LatLng(newPosition.LAT, newPosition.LONG)
      if (this.vechicleListIsClicked) {
        if (this.IMEI == newPosition.DEVICEID) {
          if (
            newPosition.LAT &&
            newPosition.LONG &&
            newPosition.LAT != ' ' &&
            newPosition.LONG != ' ' &&
            msg.prjID == Number(this.prjID)
          ) {
            var point = new google.maps.LatLng(
              newPosition.LAT,
              newPosition.LONG,
            )

            this.latlongs.push(mylatlongs)
            this.deleteMarker(
              newPosition.DEVICEID,
              mylatlongs,
              newPosition.ANGLE,
            )
            var car =
              'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'

            //   if (newPosition.TYPE == "Primary") {
            //     var color = '#93CEF3'
            //  }else{
            //   var color = 'white'
            //  }
            var color = '#4AA951'

            var icon = {
              path: car,
              scale: 0.7,
              strokeColor: 'black',
              strokeWeight: 1.3,
              fillOpacity: 2,
              fillColor: color,
              offset: '4%',
              rotation: newPosition.ANGLE, //<-- Car angle
            }

            var marker = new google.maps.Marker({
              position: point,
              icon: icon,
              title:
                newPosition.DEVICEID + '(' + newPosition.HEARTBEATDATE + ')',
            })
            marker.id = newPosition.DEVICEID
            //this.allMarkers.push(marker);

            if (this.vehicleInfoWindowClicked) {
              this.vehicleInfoWindowClicked.close()
            }
            if (newPosition.SPEED > 0) {
              var status = 'Moving'
            } else {
              var status = 'Stoped'
            }
            //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
            var content =
              "<div class='col-sm-12'>" +
              "<p class='info-deatil'><strong>IMEI:</strong>" +
              '  ' +
              newPosition.DEVICEID +
              "</p><p class='info-deatil'><strong>Vehicle No:</strong>" +
              '  ' +
              newPosition.RCNO +
              "</p><p class='info-deatil'><strong>Speed:</strong>" +
              '  ' +
              newPosition.SPEED +
              ' ' +
              'Km/h' +
              "</p><p class='info-deatil'><strong>Last Updated:</strong>" +
              '  ' +
              newPosition.HEARTBEATDATE +
              ' ' +
              // "</p><p class='info-deatil'><strong>Distance :</strong>" + "  " + (newPosition.distance/1000).toFixed(2) + "</p></div>" +

              "</p><p class='info-deatil'><strong>Status:</strong>" +
              '  ' +
              "<label style='font:bold'>" +
              status +
              ' </label>' +
              '</p></div>'
            this.vehicleInfoWindowClicked.setContent(content)
            this.vehicleInfoWindowClicked.open(this.map, marker)
          }
        }
      } else {
        //   if (newPosition.TYPE == "Primary") {
        //     var color = '#93CEF3'
        //  }else{
        //   var color = 'white'
        //  }
        var color = '#4AA951'
        for (var i = 0; i < this.allMarkers.length; i++) {
          if (newPosition.DEVICEID == this.allMarkers[i].id) {
            var title =
              ' VEHNO :' +
              newPosition.RCNO +
              ' , TIME :' +
              newPosition.HEARTBEATDATE +
              ' ,  SPEED :' +
              newPosition.SPEED
            var car =
              'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
            var icon = {
              path: car,
              scale: 0.7,
              strokeColor: 'black',
              strokeWeight: 1.3,
              fillOpacity: 2,
              fillColor: color,
              offset: '4%',
              rotation: newPosition.ANGLE, //<-- Car angle
            }

            this.allMarkers[i].setIcon(icon)
            this.allMarkers[i].setPosition(mylatlongs)
            this.allMarkers[i].setTitle(title)

            this.allMarkers[i].BEAT = newPosition.beatName
            this.allMarkers[i].SPEED = newPosition.SPEED
            this.allMarkers[i].dateTime = newPosition.HEARTBEATDATE

            if (thisRef.isClickedVehicle == newPosition.DEVICEID) {
              if (this.vehicleInfoWindow) {
                this.vehicleInfoWindow.close()
              }
              if (newPosition.SPEED > 0) {
                var status = 'Moving'
              } else {
                var status = 'Stoped'
              }
              //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
              var content =
                "<div class='col-sm-12'>" +
                "<p class='info-deatil'><strong>IMEI :</strong>" +
                '  ' +
                newPosition.DEVICEID +
                "</p><p class='info-deatil'><strong>Vehicle No:</strong>" +
                '  ' +
                newPosition.RCNO +
                "</p><p class='info-deatil'><strong>Speed:</strong>" +
                '  ' +
                newPosition.SPEED +
                ' ' +
                'Km/h' +
                "</p><p class='info-deatil'><strong>Last Updated:</strong>" +
                '  ' +
                newPosition.HEARTBEATDATE +
                ' ' +
                // "</p><p class='info-deatil'><strong>Distance :</strong>" + "  " + (newPosition.distance/1000).toFixed(2) + "</p></div>" +

                "</p><p class='info-deatil'><strong>Status :</strong>" +
                '  ' +
                "<label style='font:bold'>" +
                status +
                ' </label>' +
                '</p></div>'
              this.vehicleInfoWindow.setContent(content)
              this.vehicleInfoWindow.open(this.map, this.allMarkers[i])
            }
          }
        }
        if (
          newPosition.LAT &&
          newPosition.LONG &&
          newPosition.LAT != ' ' &&
          newPosition.LONG != ' ' &&
          msg.prjID == Number(this.prjID)
        ) {
          var point = new google.maps.LatLng(
            JSON.parse(newPosition.LAT),
            JSON.parse(newPosition.LONG),
          )
          var mylatlongs = new google.maps.LatLng(
            JSON.parse(newPosition.LAT),
            JSON.parse(newPosition.LONG),
          )
          this.latlongs.push(mylatlongs)
          //this.deleteMarker(newPosition.DEVICEID, mylatlongs)
          //this.plotMarker(point, newPosition.DEVICEID, newPosition.DEVICEDATE)
        }
      }
    })

    //search box

    // this.runningVehicleByType()
    $('#divvehicledate').hide()
    this.subscription = Observable.interval(10 * 1000).subscribe((x) => {
      thisRef.refreshCount(this.prjID)
    })
    // Observable.interval(2 * 60 * 1000).subscribe((x) => {
    //     thisRef.refreshCount(this.prjID);
    // });
    // thisRef.CenterControl(thisRef.centerControlDiv, thisRef.map);
    // this.map.controls[google.maps.ControlPosition.LEFT_CENTER].push(this.centerControlDiv);
    var card = document.getElementById('pac-card')
    var input = document.getElementById('pac-input')

    thisRef.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card)

    var autocomplete = new google.maps.places.Autocomplete(input)

    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    autocomplete.bindTo('bounds', thisRef.map)

    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])

    var infowindow = new google.maps.InfoWindow()
    var infowindowContent = document.getElementById('infowindow-content')
    infowindow.setContent(infowindowContent)
    var marker = new google.maps.Marker({
      map: thisRef.map,
      anchorPoint: new google.maps.Point(0, -29),
    })

    autocomplete.addListener('place_changed', function () {
      infowindow.close()
      marker.setVisible(false)
      var place = autocomplete.getPlace()
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place.name + "'")
        return
      }

      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        thisRef.map.fitBounds(place.geometry.viewport)
      } else {
        thisRef.map.setCenter(place.geometry.location)
        thisRef.map.setZoom(17) // Why 17? Because it looks good.
      }
      marker.setPosition(place.geometry.location)
      marker.setVisible(true)

      var address = ''
      if (place.address_components) {
        address = [
          (place.address_components[0] &&
            place.address_components[0].short_name) ||
            '',
          (place.address_components[1] &&
            place.address_components[1].short_name) ||
            '',
          (place.address_components[2] &&
            place.address_components[2].short_name) ||
            '',
        ].join(' ')
      }

      infowindowContent.children['place-icon'].src = place.icon
      infowindowContent.children['place-name'].textContent = place.name
      infowindowContent.children['place-address'].textContent = address
      infowindow.open(thisRef.map, marker)
    })

    //  drawing manager

    var drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_CENTER,
        drawingModes: ['marker', 'polygon'],
      },
      polygonOptions: {
        strokeWeight: 2,
        strokeColor: '#ff0000',
      },
    })
    drawingManager.setMap(this.map)
    google.maps.event.addListener(drawingManager, 'overlaycomplete', function (
      this,
      event,
    ) {
      // Get overlay paths
      var paths = event.overlay.getPaths()
      // Remove overlay from map
      event.overlay.setMap(null)
      // Disable drawingManager
      //drawingManager.setDrawingMode(null);
      thisRef.polygon = new google.maps.Polygon({
        fillColor: '#D4D9C8',
        fillOpacity: 0,
        strokeWeight: 3,
        strokeColor: '#7620A7',
        editable: true,
        paths: paths,
        map: this.map,
      })
      var coordinatesArray = event.overlay.getPath()

      var testArray = []
      for (var a = 0; a < coordinatesArray.length; a++) {
        var arr = [coordinatesArray.getAt(a).lng()]
        arr.push(coordinatesArray.getAt(a).lat())
        testArray.push(arr)
      }
      var arr1 = [coordinatesArray.getAt(0).lng()]
      arr1.push(coordinatesArray.getAt(0).lat())
      testArray.push(arr1)

      thisRef.http
        .post(environment.apiUrl + 'vehicles/getVehicleByPolygon', testArray)
        .subscribe((data) => {
          var result = data
          thisRef.importToExcel(result)
        })
      //thisRef.getBuildingPoint("Polygon((" + testArray + "))")
    })

    // control
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/maptracker/stop/khatta.component.ts